<script setup>
import { usePage, Link } from '@inertiajs/vue3';
import { computed, ref } from 'vue';
const page = usePage()

const pageBanner = ref("/assets/images/common/page-banner.webp")
const policyBanner = ref("/assets/images/policy/policy.webp")

const isPolicyPage = computed(() => page.url.startsWith('/policy'));
const isCareerPage = computed(() => page.url.startsWith('/career'));
const isAboutPage = computed(() => page.url.startsWith('/about'));

const displayedImage = computed(() => {
    if (isPolicyPage.value || isCareerPage.value) {
        return policyBanner.value;
    } else {
        return pageBanner.value;
    }
});


</script>
<template>
    <section>
        <div class="relative -z-10 w-full h-full top-10 xl:py-64 lg:py-48 md:py-24 sm:py-24 py-28 overflow-hidden">
            <VLazyImage :src="displayedImage" alt="Background Image"
                class="absolute inset-0 object-cover w-full h-full" />
            <div class="flex flex-wrap justify-center items-center">
                <div class="container">
                    <div
                        class="z-10 md:w-3/4 relative inset-0 m-auto text-white wow animate__animated animate__zoomIn transition duration-300 animate__slow 2s">
                        <component :is="isAboutPage ? 'h2' : 'h1'"
                            class="lg:text-6xl sm:text-2xl text-2xl text-white text-center tracking-wide font-medium title-font sm:leading-10 mb-4">
                            <slot />
                        </component>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
